import DialogContent from '@mui/material/DialogContent/DialogContent';
import styled from 'styled-components';

export const DialogContentStyled = styled(DialogContent)`
    .rte-input {
        display: flex;
        overflow: auto;
        max-height: 350px;
        flex: 1 1;
        border: 2px solid lightgray;
        margin-top: 10px;
        border-radius: ${({ theme }) => theme.borderRadius.medium};
        min-height: 250px;

        padding: 20px;

        flex-direction: column;

        @media screen and (min-height: 700px) {
            max-height: 450px;
        }

        table {
            &.lightblue {
                tr:nth-child(odd) {
                    background: lightblue;
                }
            }

            .selectedCell:after {
                z-index: 2;
                position: absolute;
                content: '';
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background: rgba(200, 200, 255, 0.4);
                pointer-events: none;
            }
            margin-bottom: 25px;
            width: fit-content;
            th,
            td {
                border: 1px solid #ced4da;
                text-align: center;
                min-width: 30px;
                position: relative;
                padding: 0 5px;
            }
        }
    }
`;
